import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/sortBy.svg'
import _imports_1 from '@/assets/arrowRight.svg'


const _hoisted_1 = { class: "card mt-4 m-4" }
const _hoisted_2 = {
  class: "document-container border-b py-4 px-8 flex justify-between items-center",
  style: {"border-color":"rgba(0, 0, 0, 0.1)"}
}
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "flex parent-toggle-border border rounded-sm" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "initials-container" }
const _hoisted_9 = {
  class: "rounded-full h-8 w-8",
  style: {"background-color":"#152a43","color":"white","display":"flex","justify-content":"center","align-items":"center","margin-right":"8px"}
}
const _hoisted_10 = { class: "font-bold text-sm" }
const _hoisted_11 = { class: "toppadding px-11" }
const _hoisted_12 = { class: "font-bold" }
const _hoisted_13 = { class: "font-bold pl-1" }
const _hoisted_14 = { class: "font-bold" }
const _hoisted_15 = {
  key: 3,
  class: "pl-5 pt-2 pb-2"
}
const _hoisted_16 = {
  key: 0,
  src: _imports_1,
  style: {"padding-left":"120px","margin-top":"-16px"}
}
const _hoisted_17 = {
  key: 1,
  style: {"margin-left":"160px !important","margin-top":"-35px !important"}
}
const _hoisted_18 = { class: "key-span" }
const _hoisted_19 = { class: "font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumb = _resolveComponent("breadCrumb")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_breadCrumb, {
        routesArray: _ctx.routesArray,
        class: "ml-5 mt-6"
      }, null, 8, ["routesArray"]),
      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "font-bold pl-5 p-2" }, "Document History", -1)),
      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "font-medium pl-5 headerText" }, " A risk assessment is a process to identify potential hazards and analyze what could happen if a hazard occurs. A business impact analysis (BIA) is the process for determining the potential impacts resulting from the interruption of time sensitive or critical business processes. A risk assessment is a process to identify potential hazards and analyze what could happen if a hazard occurs. A business impact analysis (BIA) is the process for determining the potential impacts resulting from the interruption of time sensitive or critical business processes. ", -1)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-lg font-bold" }, "Name of the Document", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                class: _normalizeClass([{ 'active-tab': _ctx.activeButton === 'revision', 'inactive-tab': _ctx.activeButton !== 'revision' }, "flex items-center font-semibold justify-center rounded p-px leading-3 cursor-pointer w-28 h-7"]),
                style: {"font-size":"x-small"},
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showRevisionHistory && _ctx.showRevisionHistory(...args)))
              }, [
                (_ctx.activeButton === 'revision')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                  : _createCommentVNode("", true),
                _cache[4] || (_cache[4] = _createTextVNode(" Revision History "))
              ], 2),
              _createElementVNode("button", {
                class: _normalizeClass([{ 'active-tab': _ctx.activeButton === 'details', 'inactive-tab': _ctx.activeButton !== 'details' }, "flex items-center font-semibold justify-center rounded p-px leading-3 cursor-pointer w-28 h-7"]),
                style: {"font-size":"x-small"},
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showDetails && _ctx.showDetails(...args)))
              }, [
                (_ctx.activeButton === 'details')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                  : _createCommentVNode("", true),
                _cache[5] || (_cache[5] = _createTextVNode(" Details "))
              ], 2)
            ]),
            (_ctx.sortOrder)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "taskEditButtons w-24 h-7 border rounded-sm flex items-center justify-center p-2 mx-3.5 font-semibold",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showNewest && _ctx.showNewest(...args)))
                }, _cache[6] || (_cache[6] = [
                  _createElementVNode("img", {
                    src: _imports_0,
                    class: "h-3 mr-2.5"
                  }, null, -1),
                  _createTextVNode(" Newest ")
                ])))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "taskEditButtons w-24 h-7 border border rounded-sm flex items-center justify-center p-2 mx-3.5 font-semibold",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showNewest && _ctx.showNewest(...args)))
                }, _cache[7] || (_cache[7] = [
                  _createElementVNode("img", {
                    src: _imports_0,
                    class: "h-3 mr-2.5 rotate-180"
                  }, null, -1),
                  _createTextVNode(" Oldest ")
                ])))
          ])
        ]),
        (_ctx.showArray)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentArray, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "border-b py-4 px-8",
                  style: {"border-color":"rgba(0, 0, 0, 0.1)"}
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.getInitials(item.createdBy)), 1)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (value, key) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: key,
                        class: "line"
                      }, [
                        (key === 'createdBy')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("span", _hoisted_12, _toDisplayString(value), 1),
                              _cache[9] || (_cache[9] = _createTextVNode(" created the document "))
                            ], 64))
                          : (key === 'createdAt')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("span", _hoisted_13, _toDisplayString(value), 1),
                                _cache[10] || (_cache[10] = _createTextVNode(" at "))
                              ], 64))
                            : (key === 'time')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createElementVNode("span", _hoisted_14, _toDisplayString(value), 1),
                                  _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1))
                                ], 64))
                              : (key === 'statusCode' || key === 'updatedCode')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    _createElementVNode("div", {
                                      style: _normalizeStyle({ float: key === 'statusCode' || key === 'updatedCode' ? 'left' : 'none', 'margin-right': key === 'statusCode' || key === 'updatedCode' ? '25px' : '0', 'margin-top': key === 'updatedCode' ? '-16px' : '0' })
                                    }, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["w-24 h-5 border rounded-sm flex justify-center items-center", _ctx.getStatusClass(value)])
                                      }, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["status-text", _ctx.getStatusClass1(value)])
                                        }, _toDisplayString(key === 'statusCode' ? _ctx.getStatusText(value) : _ctx.getStatusText1(value)), 3)
                                      ], 2),
                                      (key === 'statusCode')
                                        ? (_openBlock(), _createElementBlock("img", _hoisted_16))
                                        : _createCommentVNode("", true),
                                      (key === 'updatedCode')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_17))
                                        : _createCommentVNode("", true)
                                    ], 4)
                                  ]))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                    _createElementVNode("span", _hoisted_18, _toDisplayString(key.replace(/([a-z])([A-Z])/g, '$1 $2')), 1),
                                    _cache[12] || (_cache[12] = _createTextVNode()),
                                    _cache[13] || (_cache[13] = _createElementVNode("span", { class: "colon" }, ":", -1)),
                                    _cache[14] || (_cache[14] = _createTextVNode()),
                                    _createElementVNode("span", _hoisted_19, _toDisplayString(value), 1),
                                    _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1))
                                  ], 64))
                      ]))
                    }), 128))
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}